import { ENV_DEV } from "../../../utils/window";

/**
 * Remove class
 * @param {Array<HTMLElement>} targets
 * @param {String} name
 */
const classRemove = (targets, name) => {
  if (ENV_DEV && !name) {
    console.error(
      `[TorusKit error]: No class name provided in the \`remove(class)\` action. Please use the \`<name>\` option to specify the class name you want to remove.`
    );

    return;
  }

  for (const target of targets) {
    target.classList.remove(...name.split(" "));
  }
};

export default classRemove;
